import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { CommonStatResponse } from '@/api/routes/campaigns/types';

import { fetchCampaignsStat } from './actionCreators';

interface InitialState {
  counter: number,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  counter: 0,
  isLoading: false,
  error: '',
};

// eslint-disable-next-line max-len
const getAmount = (count: CommonStatResponse) => (count?.oncar?.admin_mod_pending_count || 0) + (count?.tablet?.admin_mod_pending_count || 0);

export const campaignsStatSlice = createSlice({
  name: 'campaignsStat',
  initialState,
  reducers: {
    decrementStatCounter: (state) => {
      if (state.counter <= 0) {
        state.counter = 0;
        return;
      }
      state.counter -= 1;
    },
  },
  extraReducers: {
    [fetchCampaignsStat.fulfilled.type]: (state, action: PayloadAction<CommonStatResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.counter = getAmount(action.payload);
    },
    [fetchCampaignsStat.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchCampaignsStat.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { decrementStatCounter } = campaignsStatSlice.actions;
export default campaignsStatSlice.reducer;
